import React from 'react';

interface Attribute {
    label: string;
    value: string | number;
}

interface AttributeSection {
    title: string;
    attributes: Attribute[];
}

interface ProductAttributesProps {
    sections: AttributeSection[];
}

const ProductAttributes: React.FC<ProductAttributesProps> = ({ sections }) => {
    return (
        <div className="mt-12 border-t border-gray-200 pt-8">
            <h2 className="semiBold mb-6">Product Attributes</h2>

            {sections.map((section, sectionIndex) => (
                <div key={sectionIndex}>
                    <h3 className="semiBold mb-0">{section.title}</h3>
                    <div className="space-y-2 mb-3">
                        {section.attributes.map((attribute, attrIndex) => (
                            <div key={attrIndex} >
                                {/* <span className="text-sm text-gray-500">{attribute.label}</span> */}
                                <span className="semiGrey">{attribute.value}</span>
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ProductAttributes;